import React from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}
export default function PageTitle({ className, children }: Props) {
  return (
    <h1
      className={`text-2xl font-bold sm:text-4xl md:text-5xl ${
        className || ''
      }`}
    >
      {children}
    </h1>
  );
}

PageTitle;
